import { put, call, select } from 'redux-saga/effects'
import { reset } from 'redux-form'
import { transliterate as tr } from 'transliterations'

import { snackbarActions } from 'reduxModules/actions/SnackbarActions'
import { globalActions } from 'reduxModules/actions/GlobalActions'
import { companySelector, isPrexBusSelector } from 'reduxModules/selectors/UserSelectors'
import { confirmSaga } from 'services/sagaHelpers'

import { rsf, firestore } from '../../firebase'

export function* getCarriersSaga(action) {
  const { responseSuccess, responseFailure } = action

  try {
    const company = yield select(companySelector)
    const isPrexBus = yield select(isPrexBusSelector)
    const query = isPrexBus
      ? firestore
        .collection('carriers')
      : firestore
        .collection('carriers')
        .where("company", "==", company)

    const res = yield call(rsf.firestore.getCollection, query)

    if (!res.empty) {
      const carriers = []

      yield res.forEach(carrier => carriers.push({ id: carrier.id, ...carrier.data() }))

      yield put(responseSuccess(carriers))
    }
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час завантаження перевізників!'
    }))
  }
}

export function* getBusesSaga(action) {
  const { responseSuccess, responseFailure } = action

  try {
    const company = yield select(companySelector)
    const isPrexBus = yield select(isPrexBusSelector)
    const query = isPrexBus
      ? firestore
        .collection('buses')
      : firestore
        .collection('buses')
        .where("company", "==", company)

    const res = yield call(rsf.firestore.getCollection, query)

    if (!res.empty) {
      const buses = []

      yield res.forEach(bus => buses.push({ id: bus.id, ...bus.data() }))

      yield put(responseSuccess(buses))
    }
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час завантаження транспортних засобів!'
    }))
  }
}

export function* getDriversSaga(action) {
  const { responseSuccess, responseFailure } = action

  try {
    const company = yield select(companySelector)
    const isPrexBus = yield select(isPrexBusSelector)
    const query = isPrexBus
      ? firestore
        .collection('drivers')
      : firestore
        .collection('drivers')
        .where("company", "==", company)

    const res = yield call(rsf.firestore.getCollection, query)

    if (!res.empty) {
      const drivers = []

      yield res.forEach(driver => drivers.push({ id: driver.id, ...driver.data() }))

      yield put(responseSuccess(drivers))
    }
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час завантаження водіїв!'
    }))
  }
}

export function* createDriverSaga(action) {
  const { responseSuccess, responseFailure, data } = action

  try {
    const company = yield select(companySelector)
    const driver = data.label.split(' ')
    const id = tr(`${driver[0].toLowerCase()}_${driver[1].toLowerCase()}_${company}`)

    yield call(
      rsf.firestore.setDocument,
      `drivers/${id}`,
      { ...data, company }
    )

    yield put(globalActions.getDrivers())
    yield put(responseSuccess({ id, ...data, company }))
    yield put(reset('createDriver'))
    yield put(snackbarActions.showSnackbar({
      type: 'success',
      message: 'Водій успішно добавлений!'
    }))
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час добавлення водія!'
    }))
  }
}

export function* createBusSaga(action) {
  const { responseSuccess, responseFailure, data } = action

  try {
    const company = yield select(companySelector)
    const bus = data.label.split('|')

    if (!bus[1]) {
      yield put(snackbarActions.showSnackbar({
        type: 'error',
        message: 'Назва автобуса і реєстраційний номер повинні бути розділені знаком | '
      }))

      return
    }

    const id = `${tr(bus[1].trim())}_${company}`

    yield call(
      rsf.firestore.setDocument,
      `buses/${id}`,
      { ...data, company }
    )

    yield put(responseSuccess({ id, ...data, company }))
    yield put(reset('createBus'))
    yield put(snackbarActions.showSnackbar({
      type: 'success',
      message: 'Автобус успішно добавлений!'
    }))
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час добавлення автобуса!'
    }))
  }
}

export function* setDriverSaga(action) {
  const { responseSuccess, responseFailure, data: { id, value } } = action

  try {
    yield call(
      rsf.firestore.setDocument,
      `drivers/${id}`,
      {
        label: value
      },
      { merge: true }
    )

    yield put(responseSuccess())
    yield put(snackbarActions.showSnackbar({
      type: 'success',
      message: 'Водій успішно оновлений!'
    }))
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час оновлення водія!'
    }))
  }
}

export function* setBusSaga(action) {
  const { responseSuccess, responseFailure, data: { id, field, value } } = action

  try {
    yield call(
      rsf.firestore.setDocument,
      `buses/${id}`,
      {
        [field]: value
      },
      { merge: true }
    )

    yield put(responseSuccess())
    yield put(snackbarActions.showSnackbar({
      type: 'success',
      message: 'Автобус успішно оновлений!'
    }))
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час оновлення автобуса!'
    }))
  }
}

export function* deleteDriverSaga(action) {
  const { responseSuccess, responseFailure, data: { id } } = action

  try {
    const confirmed = yield call(confirmSaga, 'deleteDriver')

    if (confirmed) {
      yield call(rsf.firestore.deleteDocument, `drivers/${id}`)

      yield put(globalActions.getDrivers())
      yield put(responseSuccess())
      yield put(snackbarActions.showSnackbar({
        type: 'success',
        message: 'Водій успішно видалений!'
      }))
    } else {
      yield put(responseFailure())
    }
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час видалення водія!'
    }))
  }
}

export function* deleteBusSaga(action) {
  const { responseSuccess, responseFailure, data: { id } } = action

  try {
    const confirmed = yield call(confirmSaga, 'deleteBus')

    if (confirmed) {
      yield call(rsf.firestore.deleteDocument, `buses/${id}`)

      yield put(responseSuccess({ id }))
      yield put(snackbarActions.showSnackbar({
        type: 'success',
        message: 'Автобус успішно видалений!'
      }))
    } else {
      yield put(responseFailure())
    }
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час видалення автобуса!'
    }))
  }
}



// WEBPACK FOOTER //
// ./src/reduxModules/sagas/GlobalSaga.js